import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { TabList, TabListItem } from '@dndbeyond/character-common-components/es';
import { BeveledBoxSvg517x660, BeveledBoxSvg623x660, BoxBackground } from '@dndbeyond/character-components/es';
import { CharacterTheme, rulesEngineSelectors } from '@dndbeyond/character-rules-engine/es';

import Subsection from '../../../Shared/components/Subsection';
import { StyleSizeTypeEnum } from '../../../Shared/reducers/appEnv';
import { appEnvSelectors } from '../../../Shared/selectors';
import { AppEnvDimensionsState } from '../../../Shared/stores/typings';
import { SheetAppState } from '../../typings';
import Actions from '../Actions';
import Description from '../Description';
import Equipment from '../Equipment';
import Extras from '../Extras';
import Features from '../Features';
import Notes from '../Notes';
import Spells from '../Spells';

const TAB_KEY = {
    ACTIONS: 'ACTIONS',
    SPELLS: 'SPELLS',
    EQUIPMENT: 'EQUIPMENT',
    DESCRIPTION: 'DESCRIPTION',
    NOTES: 'NOTES',
    FEATURES_TRAITS: 'FEATURES_TRAITS',
    EXTRAS: 'EXTRAS',
};

interface Props extends DispatchProp {
    hasSpells: boolean;
    dimensions: AppEnvDimensionsState;
    theme: CharacterTheme;
    isReadonly: boolean;
}

class PrimaryBox extends React.PureComponent<Props, {}> {
    render() {
        const { hasSpells, dimensions, theme, isReadonly } = this.props;

        let BoxBackgroundComponent: React.ComponentType = BeveledBoxSvg517x660;
        if (dimensions.styleSizeType > StyleSizeTypeEnum.DESKTOP) {
            BoxBackgroundComponent = BeveledBoxSvg623x660;
        }

        return (
            <Subsection name="Primary Box">
                <div className={`ct-primary-box ${theme.isDarkMode ? 'ct-primary-box--dark-mode' : ''}`}>
                    <BoxBackground StyleComponent={BoxBackgroundComponent} theme={theme} />
                    <TabList initialActiveKey={TAB_KEY.ACTIONS}>
                        <TabListItem tkey={TAB_KEY.ACTIONS} label="Actions" className="ct-primary-box__tab--actions">
                            <Actions />
                        </TabListItem>
                        {hasSpells && (
                            <TabListItem tkey={TAB_KEY.SPELLS} label="Spells" className="ct-primary-box__tab--spells">
                                <Spells />
                            </TabListItem>
                        )}
                        <TabListItem
                            tkey={TAB_KEY.EQUIPMENT}
                            label="Inventory"
                            className="ct-primary-box__tab--equipment"
                        >
                            <Equipment />
                        </TabListItem>
                        <TabListItem
                            tkey={TAB_KEY.FEATURES_TRAITS}
                            label="Features & Traits"
                            className="ct-primary-box__tab--features"
                        >
                            <Features />
                        </TabListItem>
                        {!isReadonly && (
                            <TabListItem
                                tkey={TAB_KEY.DESCRIPTION}
                                label="Description"
                                className="ct-primary-box__tab--description"
                            >
                                <Description theme={theme} />
                            </TabListItem>
                        )}
                        {!isReadonly && (
                            <TabListItem tkey={TAB_KEY.NOTES} label="Notes" className="ct-primary-box__tab--notes">
                                <Notes theme={theme} />
                            </TabListItem>
                        )}
                        <TabListItem tkey={TAB_KEY.EXTRAS} label="Extras" className="ct-primary-box__tab--extras">
                            <Extras />
                        </TabListItem>
                    </TabList>
                </div>
            </Subsection>
        );
    }
}

function mapStateToProps(state: SheetAppState) {
    return {
        hasSpells: rulesEngineSelectors.hasSpells(state),
        dimensions: appEnvSelectors.getDimensions(state),
        theme: rulesEngineSelectors.getCharacterTheme(state),
        isReadonly: appEnvSelectors.getIsReadonly(state),
    };
}
export default connect(mapStateToProps)(PrimaryBox);
